module.exports = __webpack_public_path__ + "img/hardwareRouter7.6f8281e4.png";